<template>
    <div id="omne">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="img-fluid rounded-circle" src="../assets/Nikol-omne.jpg" alt="Nikol">
                    </div>
                    <div class="col-sm-8 pt-lg-5 pt-4">
                        <p class="text-title">Nikol Wetterová</p>
                        <p class="text">Jsem fotografka, která se snaží zachytit moment se vším všudy tak, aby fotka
                            sama o sobě vykládala příběh člověka, místa, momentu…</p>
                        <p class="text">Nejvíce se cítím ve svém živlu, když je mi dovoleno vyjít ze zažitých kolejí a
                            fotit z nezvyklých úhlů a pohledů. Chci, aby
                            si pozorovatel mé fotky řekl: “Aha, takhle to vlastně doopravdy vypadá…, tak krásné to v té
                            chvíli bylo…” Pokud to jde, ráda poznám klienty
                            ještě před focením, zajít na kávu, ujasnit si představy obou stran. Chci, aby se klient
                            cítil natolik přirozeně a příjemně, že zapomene,
                            že ho fotím. Nezaměřuji se jen na určité typy focení, ale sobě samé vytvářím výzvy a
                            nechávám se obohacovat rozličnou poptávkou.</p>
                        <p class="text">Pravidelně fotím divadelní představení pro Městské divadlo Brno, reportážní foto všeho druhu,
                            portréty v exteriéru i interiéru, svatby, koncerty i těhotenské fotky.</p>
                        <p class="text">Každé focení je jedinečné. Napište mi, jaké zachycení momentů byste
                            si přáli a já Vám navrhnu cenu přímo na míru tak, aby vyhovovala jak Vám, tak i mně.</p>
                        <p class="text">V případě zájmu o bližší informace mě neváhejte kontaktovat.</p>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: "aboutUs"
    }
</script>

<style scoped>
    h1 {
        padding-bottom: 2.5rem;
        padding-left: 15px;
        color: black;
        padding-top: 10px;
        font-size: 3rem;
    }
    .text-title {
        font-family: 'Nunito', sans-serif;
        font-size: 2.5rem;
        color: #fff;
    }
    .text {
        font-family: 'Nunito', sans-serif;
    }
    #omne {
        padding-top: 6em;
        background-color: black;
        color: #fff;
        padding-bottom: 6em;
    }
    @media screen and (max-width: 600px){
        #omne {
            padding-top: 0;
        }
    }

    #omne .img-fluid {
        max-width: 95%;
        margin-top: 4.1em;
    }

</style>